import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { 
  ChevronLeft, 
  ChevronRight, 
  Home, 
  Volume2, 
  VolumeX, 
  Languages, 
  Check, 
  ChevronDown 
} from 'lucide-react';

// --- กำหนดรายการภาษาที่รองรับ ---
const LANG_OPTIONS = [
  { code: 'TH', label: 'ไทย', flag: '🇹🇭' },
  { code: 'EN', label: 'English', flag: '🇬🇧' },
  { code: 'KR', label: '한국어', flag: '🇰🇷' },
  { code: 'CN', label: '中文', flag: '🇨🇳' }
];

// --- สร้าง Dictionary สำหรับข้อความ UI ---
const UI_TEXT = {
  TH: {
    backToGames: "เข้าสู่เกม",
    mute: "ปิดเสียง",
    unmute: "เปิดเสียง",
    switchLang: "เปลี่ยนภาษา"
  },
  EN: {
    backToGames: "Enter Game",
    mute: "Mute",
    unmute: "Unmute",
    switchLang: "Change Language"
  },
  KR: {
    backToGames: "플레이", 
    mute: "음소거",
    unmute: "소리 켜기",
    switchLang: "언어 변경"
  },
  CN: {
    backToGames: "进入游戏",
    mute: "静音",
    unmute: "取消静音",
    switchLang: "更改语言"
  }
};

// --- ข้อมูลฉาก ---
const STORY_SCENES = [
  {
    id: 1,
    image: {
      th: "/images/1.jpg",
      en: "/images/1_en.jpg",
      kr: "/images/1_kr.jpg",
      cn: "/images/1_cn.jpg"
    },
    bg: "bg-indigo-950",
    audio: null
  },
  {
    id: 2,
    image: {
      th: "/images/2.jpg",
      en: "/images/2_en.jpg",
      kr: "/images/2_kr.jpg",
      cn: "/images/2_cn.jpg"
    },
    bg: "bg-purple-950",
    audio: {
      th: "/sounds/scene2.mp3",
      en: "/sounds/scene2_en.mp3",
      kr: "/sounds/scene2_kr.mp3",
      cn: "/sounds/scene2_cn.mp3"
    }
  },
  {
    id: 3,
    image: {
      th: "/images/3.jpg",
      en: "/images/3_en.jpg",
      kr: "/images/3_kr.jpg",
      cn: "/images/3_cn.jpg"
    },
    bg: "bg-pink-950",
    audio: {
      th: "/sounds/scene3.mp3",
      en: "/sounds/scene3_en.mp3",
      kr: "/sounds/scene3_kr.mp3",
      cn: "/sounds/scene3_cn.mp3"
    }
  },
  {
    id: 4,
    image: {
      th: "/images/4.jpg",
      en: "/images/4_en.jpg",
      kr: "/images/4_kr.jpg",
      cn: "/images/4_cn.jpg"
    },
    bg: "bg-indigo-950",
    audio: {
      th: "/sounds/scene4.mp3",
      en: "/sounds/scene4_en.mp3",
      kr: "/sounds/scene4_kr.mp3",
      cn: "/sounds/scene4_cn.mp3"
    }
  },
  {
    id: 5,
    image: {
      th: "/images/5.jpg",
      en: "/images/5_en.jpg",
      kr: "/images/5_kr.jpg",
      cn: "/images/5_cn.jpg"
    },
    bg: "bg-purple-950",
    audio: {
      th: "/sounds/scene5.mp3",
      en: "/sounds/scene5_en.mp3",
      kr: "/sounds/scene5_kr.mp3",
      cn: "/sounds/scene5_cn.mp3"
    }
  },
  {
    id: 6,
    image: {
      th: "/images/6.jpg",
      en: "/images/6_en.jpg",
      kr: "/images/6_kr.jpg",
      cn: "/images/6_cn.jpg"
    },
    bg: "bg-pink-950",
    audio: {
      th: "/sounds/scene6.mp3",
      en: "/sounds/scene6_en.mp3",
      kr: "/sounds/scene6_kr.mp3",
      cn: "/sounds/scene6_cn.mp3"
    }
  },
  {
    id: 7,
    image: {
      th: "/images/7.jpg",
      en: "/images/7_en.jpg",
      kr: "/images/7_kr.jpg",
      cn: "/images/7_cn.jpg"
    },
    bg: "bg-indigo-950",
    audio: {
      th: "/sounds/scene7.mp3",
      en: "/sounds/scene7_en.mp3",
      kr: "/sounds/scene7_kr.mp3",
      cn: "/sounds/scene7_cn.mp3"
    }
  },
  {
    id: 8,
    image: {
      th: "/images/8.jpg",
      en: "/images/8_en.jpg",
      kr: "/images/8_kr.jpg",
      cn: "/images/8_cn.jpg"
    },
    bg: "bg-purple-950",
    audio: {
      th: "/sounds/scene8.mp3",
      en: "/sounds/scene8_en.mp3",
      kr: "/sounds/scene8_kr.mp3",
      cn: "/sounds/scene8_cn.mp3"
    }
  },
  {
    id: 9,
    image: {
      th: "/images/9.jpg",
      en: "/images/9_en.jpg",
      kr: "/images/9_kr.jpg",
      cn: "/images/9_cn.jpg"
    },
    bg: "bg-pink-950",
    audio: {
      th: "/sounds/scene9.mp3",
      en: "/sounds/scene9_en.mp3",
      kr: "/sounds/scene9_kr.mp3",
      cn: "/sounds/scene9_cn.mp3"
    }
  },
  {
    id: 10,
    image: {
      th: "/images/10.jpg",
      en: "/images/10_en.jpg",
      kr: "/images/10_kr.jpg",
      cn: "/images/10_cn.jpg"
    },
    bg: "bg-indigo-950",
    audio: {
      th: "/sounds/scene10.mp3",
      en: "/sounds/scene10_en.mp3",
      kr: "/sounds/scene10_kr.mp3",
      cn: "/sounds/scene10_cn.mp3"
    }
  },
  {
    id: 11,
    image: {
      th: "/images/11.jpg",
      en: "/images/11_en.jpg",
      kr: "/images/11_kr.jpg",
      cn: "/images/11_cn.jpg"
    },
    bg: "bg-purple-950",
    audio: {
      th: "/sounds/scene11.mp3",
      en: "/sounds/scene11_en.mp3",
      kr: "/sounds/scene11_kr.mp3",
      cn: "/sounds/scene11_cn.mp3"
    }
  },
  {
    id: 12,
    image: {
      th: "/images/12.jpg",
      en: "/images/12_en.jpg",
      kr: "/images/12_kr.jpg",
      cn: "/images/12_cn.jpg"
    },
    bg: "bg-pink-950",
    audio: {
      th: "/sounds/scene12.mp3",
      en: "/sounds/scene12_en.mp3",
      kr: "/sounds/scene12_kr.mp3",
      cn: "/sounds/scene12_cn.mp3"
    }
  },
  {
    id: 13,
    image: {
      th: "/images/13.jpg",
      en: "/images/13_en.jpg",
      kr: "/images/13_kr.jpg",
      cn: "/images/13_cn.jpg"
    },
    bg: "bg-indigo-950",
    audio: {
      th: "/sounds/scene13.mp3",
      en: "/sounds/scene13_en.mp3",
      kr: "/sounds/scene13_kr.mp3",
      cn: "/sounds/scene13_cn.mp3"
    }
  },
];

const MatanapathaStoryPage = () => {
  const [currentSceneIndex, setCurrentSceneIndex] = useState(0);
  const [isMuted, setIsMuted] = useState(false);
  const [isAudioLoaded, setIsAudioLoaded] = useState(false);

  // --- State ภาษา และ State เปิด/ปิดเมนูเลือกภาษา ---
  const [language, setLanguage] = useState('TH');
  const [showLangMenu, setShowLangMenu] = useState(false);
  
  const langKey = language.toLowerCase(); // 'th', 'en', 'kr', 'cn'
  const audioRef = useRef(new Audio());

  // ใช้ Ref เพื่อตรวจสอบการคลิกนอกเมนู
  const menuRef = useRef(null);

  const currentScene = STORY_SCENES[currentSceneIndex];
  const isLastScene = currentSceneIndex === STORY_SCENES.length - 1;
  const uiText = UI_TEXT[language];

  // --- ปิดเมนูเมื่อคลิกที่อื่น ---
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowLangMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // --- Audio Cleanup ---
  useEffect(() => {
    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
        audioRef.current.src = "";
      }
    };
  }, []);

  // --- Audio Logic ---
  useEffect(() => {
    audioRef.current.pause();
    audioRef.current.currentTime = 0;
    setIsAudioLoaded(false);

    const handleLoadedMetadata = () => {
      setIsAudioLoaded(true);
      if (!isMuted) audioRef.current.play().catch(() => { });
    };

    audioRef.current.addEventListener('loadedmetadata', handleLoadedMetadata);

    // เช็คว่ามีเสียงของภาษานั้นหรือไม่
    const audioSrc = currentScene.audio ? currentScene.audio[langKey] : null;

    if (audioSrc) {
      audioRef.current.src = audioSrc;
      audioRef.current.volume = 0.6;
      audioRef.current.load();
    } else {
      setIsAudioLoaded(true);
    }

    return () => {
      audioRef.current.removeEventListener('loadedmetadata', handleLoadedMetadata);
    };
  }, [currentSceneIndex, currentScene, language, isMuted, langKey]);

  // --- Mute Toggle Logic ---
  useEffect(() => {
    const audioSrc = currentScene.audio ? currentScene.audio[langKey] : null;
    if (isMuted) {
      audioRef.current.pause();
    } else if (isAudioLoaded && audioSrc) {
      audioRef.current.play().catch(() => { });
    }
  }, [isMuted, isAudioLoaded, currentScene, langKey]);

  const changeScene = (direction) => {
    const newIndex = direction === 'next' ? currentSceneIndex + 1 : currentSceneIndex - 1;
    if (newIndex >= 0 && newIndex < STORY_SCENES.length) setCurrentSceneIndex(newIndex);
  };

  const handleLanguageSelect = (code) => {
    setLanguage(code);
    setShowLangMenu(false);
  };

  const getSceneImage = () => {
    return currentScene.image[langKey] || currentScene.image['th'];
  };

  return (
    <div className="relative w-full h-screen overflow-hidden bg-gray-900 text-white font-sans">

      {/* ส่วนแสดงรูปภาพ (เต็มจอ) */}
      <div className={`
        relative 
        w-full h-full 
        flex items-center justify-center 
        transition-colors duration-700
        ${currentScene.bg}
      `}>
        <div className="w-full h-full flex items-center justify-center">
          <img
            key={`${currentScene.id}-${language}`}
            src={getSceneImage()}
            alt="Scene"
            className="max-h-full max-w-full object-contain animate-fade-in-up"
          />
        </div>

        {/* --- Touch Controls & Visual Arrows --- */}
        <div
          onClick={() => changeScene('prev')}
          className={`absolute top-0 left-0 w-1/4 h-full z-10 cursor-pointer group flex items-center justify-start pl-2 md:pl-4
            ${currentSceneIndex === 0 ? 'hidden' : ''}`}
        >
          <div className="p-2 rounded-full bg-black/20 text-white/50 group-hover:text-white group-hover:bg-black/50 transition-all transform group-hover:-translate-x-1">
            <ChevronLeft className="w-8 h-8 md:w-12 md:h-12 drop-shadow-md" />
          </div>
        </div>

        <div
          onClick={() => !isLastScene && changeScene('next')}
          className={`absolute top-0 right-0 w-3/4 h-full z-10 cursor-pointer group flex items-center justify-end pr-2 md:pr-4
            ${isLastScene ? 'hidden' : ''}`}
        >
          <div className="p-2 rounded-full bg-black/20 text-white/70 group-hover:text-white group-hover:bg-black/50 transition-all animate-pulse group-hover:animate-none transform group-hover:translate-x-1">
            <ChevronRight className="w-8 h-8 md:w-12 md:h-12 drop-shadow-md" />
          </div>
        </div>
      </div>

      {/* --- ปุ่มควบคุมเมนู (มุมซ้ายบน) --- */}
      <div className="absolute top-4 left-4 z-50 flex gap-2">
        <Link
          to="/games"
          className="flex items-center justify-center w-10 h-10 bg-white/80 backdrop-blur-sm rounded-full shadow-md text-amber-800 hover:bg-white hover:scale-110 transition-all border border-amber-100"
          title={uiText.backToGames}
          onPointerDown={(e) => e.stopPropagation()}
        >
          <Home className="w-5 h-5" />
        </Link>
      </div>

      {/* --- โซนขวาบน: ปุ่มควบคุม (แนวตั้ง) --- */}
      {/* เพิ่ม flex-col และ items-end เพื่อจัดเรียงลงมาและชิดขวา */}
      <div className="absolute top-4 right-4 z-50 flex flex-col gap-2 items-end" ref={menuRef}>
        
        {/* 1. ปุ่มเปิด-ปิดเสียง (ย้ายมาไว้บนสุด) */}
        <button
          onClick={(e) => {
            e.stopPropagation();
            setIsMuted(!isMuted);
          }}
          className="flex items-center justify-center w-10 h-10 bg-white/80 backdrop-blur-sm rounded-full shadow-md text-amber-800 hover:bg-white hover:scale-110 transition-all border border-amber-100"
          title={isMuted ? uiText.unmute : uiText.mute}
        >
          {isMuted ? <VolumeX className="w-5 h-5" /> : <Volume2 className="w-5 h-5" />}
        </button>

        {/* 2. ปุ่มเลือกภาษา (ย้ายมาไว้ด้านล่าง) */}
        <div className="relative">
            <button
            onClick={(e) => {
                e.stopPropagation();
                setShowLangMenu(!showLangMenu);
            }}
            className="flex items-center justify-center gap-1 h-10 px-3 bg-white/80 backdrop-blur-sm rounded-full shadow-md text-amber-800 hover:bg-white transition-all border border-amber-100"
            title={uiText.switchLang}
            >
            <Languages className="w-5 h-5" />
            <span className="text-sm font-bold uppercase">{language}</span>
            <ChevronDown className={`w-3 h-3 transition-transform ${showLangMenu ? 'rotate-180' : ''}`} />
            </button>

            {/* Dropdown Menu */}
            {showLangMenu && (
            <div className="absolute top-12 right-0 bg-white rounded-xl shadow-lg border border-amber-100 overflow-hidden w-32 animate-in fade-in zoom-in-95 duration-200">
                <div className="py-1">
                {LANG_OPTIONS.map((lang) => (
                    <button
                    key={lang.code}
                    onClick={() => handleLanguageSelect(lang.code)}
                    className={`w-full text-left px-4 py-2 text-sm flex items-center justify-between hover:bg-amber-50 transition-colors
                        ${language === lang.code ? 'text-amber-700 font-bold bg-amber-50/50' : 'text-gray-700'}
                    `}
                    >
                    <span className="flex items-center gap-2">
                        <span>{lang.flag}</span> {lang.label}
                    </span>
                    {language === lang.code && <Check className="w-3 h-3" />}
                    </button>
                ))}
                </div>
            </div>
            )}
        </div>

      </div>

    </div>
  );
};

export default MatanapathaStoryPage;